import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { Observable } from 'rxjs';
import { GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { Optional } from 'typescript-optional';
@Injectable({
  providedIn: 'root'
})
export class InternalCustomInternalServiceClaimService extends BaseApiTemplateService<GenericDocContainerModel> {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX +
    'internal-custom-internal-service-claims';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX +
      'internal-custom-internal-service-claims';
    this.httpClient = http;
  }

  public printPdf(guid: string, templateDocId: string, printServiceClassName: string, apiVisa: ApiVisa): Observable<Blob> {
    let params = new HttpParams()
      .set('templateDocId', templateDocId)
      .set('printServiceClassName', printServiceClassName);

    return this.httpClient.get<Blob>(
      this.apiUrl + '/print-pdf/' + guid,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    customParam: Optional<string>,
    apiVisa: ApiVisa
  ): Observable<Blob> {
    let params;

    if (customParam.isPresent()) {
        params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid)
        .set('customParam', customParam.get());
    } else {
        params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid);
    }

    return this.httpClient.get<Blob>(
      this.apiUrl + '/print-jasper-pdf/' + guid,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }
}
